import { Route } from '@angular/router';
import { IsAdminGuard } from '@spotter/guards/login-guard';

/** Adds the pages for admin routes. */
export function addAdminPageRoutes(): Route[] {
  return [
    {
      path: 'admin/dashboard', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/admin/admin-dashboard-page/admin-dashboard-page.component').then(m => m.AdminDashboardPageComponent)
    },
    {
      path: 'admin/documentation', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/admin/admin-help-page/admin-help-page.component').then(m => m.AdminHelpPageComponent)
    },
    {
      path: 'admin/server', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/admin/admin-server/admin-server.page').then(m => m.AdminServerPage)
    },
    {
      path: 'admin/data', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/admin/admin-data/admin-data.page').then(m => m.AdminDataPage)
    },
    {
      path: 'admin/notifications', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/admin/notifications/notifications.page').then(m => m.NotificationsPage)
    },
    {
      path: 'admin/achievements', canActivate: [IsAdminGuard],
      loadComponent: () => import('../pages/admin/achievements/achievements.page').then(m => m.AchievementsPage)
    },
  ];
}
